import React from "react";
import { connect } from "react-redux";
import { Translate } from "react-localize-redux";
import { Field, reduxForm, reset } from "redux-form";
import { Button, InputGroup, InputGroupAddon, Input, Form } from "reactstrap";
import {
  searchProfilesAction,
  resetSearchProfilesAction
} from "../../../redux/actions/profile.actions";
import "./styles.scss";

const renderSearchInput = field => (
  <Translate>
    {({ translate }) => (
      <Input
        id={field.id}
        type={field.type}
        placeholder={translate("searchPlaceholder")}
        autoComplete="off"
        {...field.input}
      />
    )}
  </Translate>
);

const SearchForm = props => (
  <form
    id="search-form"
    onSubmit={props.handleSubmit(value =>
      props.searchProfilesAction(value.searchValue)
    )}
  >
    <InputGroup id="search-box-container">
      <Field
        name="searchValue"
        type="text"
        id="search-box"
        hideLabel={true}
        component={renderSearchInput}

      />
      <InputGroupAddon addonType="append">
        {!!props.searchResults.length && (
          <Button
            id="search-btn"
            onClick={() => {
              props.reset("SearchForm");
              props.resetSearchProfilesAction();
            }}
          >
            <i className="fa fa-times" />
          </Button>
        )}
        <Button id="search-btn">
          <i className="fa fa-search" />
        </Button>
      </InputGroupAddon>
    </InputGroup>
  </form>
);

const mapStateToProps = ({ profile }) => ({
  searchResults: profile.searchResults
});

export default reduxForm({
  validate: values => {},
  form: "SearchForm"
})(
  connect(
    mapStateToProps,
    { searchProfilesAction, resetSearchProfilesAction, reset }
  )(SearchForm)
);



// WEBPACK FOOTER //
// ./src/components/forms/SearchForm/SearchForm.jsx